import { Box, Grid, Button, Typography } from "@material-ui/core";
import React, { useState } from "react";
import CustomInput from "../../../../../Components/CustomInput";
import CustomSelect from "../../../../../Components/CustomSelect";

import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import DataService from "../../../../../Service";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import { useDispatch } from "react-redux";

function Alert(props) {
  const dispatch = useDispatch();

  const [checked, setChecked] = useState({});
  const [userData, setUserData] = useState({
    alert_status: "Red",
    alert_message: "",
  });

  const setInputState = (inputStateValue, inputId) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
  };
  const onChangeItem = (selectedItemValue, inputId, routeFrom) => {
    console.log(selectedItemValue, inputId, routeFrom);
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };
  const handleChange = (e) => {
    setChecked({
      ...checked,
      [e.target.name]: e.target.checked,
    });
  };
  const sendAlert = (e) => {
    const localArr = [];
    for (const key in checked) {
      checked[key] && localArr.push(key);
    }

    const pdata = {
      assignment_id: props.assignmentId,
      ...userData,
      send_to: localArr.join(","),
    };
    DataService.createData(pdata, "create_assignment_alerts").then(
      (response) => {
        dispatch(showSnackbar("Success", [response.message]));
        props.handleConfirmationClose();
      }
    );
  };

  return (
    <Box>
      <Grid container direction="row" style={{ marginBottom: 20 }} spacing={1}>
        <Grid item xs={3}>
          <Typography>Alert message</Typography>
        </Grid>
        <Grid item xs={9}>
          <CustomInput
            autoFocus
            id="alert_message"
            multiline={true}
            rows={4}
            variant="outlined"
            placeholder="Alert message"
            parentcall={setInputState}
            value={userData.alert_message}
          />
        </Grid>
        <Grid item xs={3}>
          <Typography>Alert status</Typography>
        </Grid>
        <Grid item xs={9}>
          <CustomSelect
            id="alert_status"
            labelText="Select alert status"
            displayEmpty
            variant="outlined"
            itemArr={["Red", "Amber", "Green"]}
            parentcall={onChangeItem}
            defaultValue={userData.alert_status}
          />
        </Grid>
        <Grid item xs={3}>
          <Typography>Send to </Typography>
        </Grid>
        <Grid item xs={9}>
          <Grid
            container
            direction="row"
            alignItems="center"
            style={{ marginBottom: 20 }}
            spacing={1}
          >
            {["Coach", "Line manager", "Coachee", "HRBP"].map((option) => {
              return (
                <Grid item xs={6}>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={(e) => handleChange(e)}
                          name={option}
                          color="primary"
                        />
                      }
                      label={option}
                    />
                  </FormGroup>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        alignItems="center"
        style={{ marginBottom: 10 }}
      >
        <Grid item xs={12}>
          <Box textAlign="right">
            <Button
              disableElevation
              variant="contained"
              onClick={props.handleConfirmationClose}
              style={{ textTransform: "none", marginRight: 10 }}
            >
              Cancel
            </Button>
            <Button
              disableElevation
              variant="contained"
              onClick={sendAlert}
              color="primary"
              style={{ textTransform: "none" }}
            >
              Send alert
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Alert;
